import React from 'react';
import s from './icon-img.module.scss';

export default function index({ src, alt, className, ...other }) {
  return (
    <img
      src={`/icons/${src}.svg`}
      alt={alt || `icon-${src}`}
      className={`${s.iconImg} ${className || ''}`}
      {...other}
    />
  );
}
